import type { Component } from "vue";
import HotspotIcon from "~icons/f7/wifi";
import DebugIcon from "~icons/fa6-solid/bug";
import DevToolsIcon from "~icons/fa6-solid/hashtag";
import DocumentIcon from "~icons/gg/file-document";
import ReportIcon from "~icons/mdi/report-bar";
import NotificationIcon from "~icons/mynaui/send-solid";
import WhatsAppIcon from "~icons/simple-icons/whatsapp";
import MarketingIcon from "~icons/tabler/briefcase";
import InternetIcon from "~icons/tdesign/internet";
import AgentIcon from "~icons/tdesign/money";
import type { Privilege } from "../common/privilege.common";
import { AdminRoutes } from "../pages/admin/admin.route";
import { AgentInvoiceRoutes } from "../pages/agent_invoice/agent_invoice.route";
import { AgentPaymentRoutes } from "../pages/agent_payment/agent_payment.route";
import { AgentSettlementRoutes } from "../pages/agent_settlement/agent_settlement.route";
import { AgentSubscriptionRoutes } from "../pages/agent_subscription/agent_subscription.route";
import { APIKeyRoutes } from "../pages/api_key/api_key.route";
import { AssociateRoutes } from "../pages/associate/associate.route";
import { AssociateAgentRoutes } from "../pages/associate_agent/associate_agent.route";
import { AssociateLegalsRoutes } from "../pages/associate_legals/associate_legals.route";
import { AssociateMarketingRoutes } from "../pages/associate_marketing/associate_marketing.route";
import { AssociatePresenceRoutes } from "../pages/associate_presence/associate_presence.route";
import { AssociateRegistrationRoutes } from "../pages/associate_registration/associate_registration.route";
import { AssociateSettingsRoutes } from "../pages/associate_settings/associate_settings.route";
import { AssociateUserRoutes } from "../pages/associate_user/associate_user.route";
import { AssociateWagentRoutes } from "../pages/associate_wagent/associate_wagent.route";
import { AuditProductInternetRoutes } from "../pages/audit_product_internet/audit_product_internet.route";
import { AuditSubscriptionRoutes } from "../pages/audit_subscription/audit_subscription.route";
import { AuditorRoutes } from "../pages/auditor/auditor.route";
import { CustomerRoutes } from "../pages/customer/customer.route";
import { CustomerInvoiceRoutes } from "../pages/customer_invoice/customer_invoice.route";
import { DebugToolsRoutes } from "../pages/debug_tools/debug_tools.route";
import { DevToolsRoutes } from "../pages/devtools/devtools.route";
import { FeatureTogglesRoutes } from "../pages/feature_toggles/feature_toggles.route";
import { FinanceAccountRoutes } from "../pages/finance_account/finance_account.route";
import { FinanceDisbursementRoutes } from "../pages/finance_disbursement/finance_disbursement.route";
import { FinanceInvoiceRoutes } from "../pages/finance_invoice/finance_invoice.route";
import { FinanceReportRoutes } from "../pages/finance_report/finance_report.route";
import { FinanceTaxRoutes } from "../pages/finance_tax/finance_tax.route";
import { HotspotTemplateRoutes } from "../pages/hotspot_template/hotspot_template.route";
import { HotspotVoucherRoutes } from "../pages/hotspot_voucher/hotspot_voucher.route";
import { LegalsRoutes } from "../pages/legals/legals.route";
import { LocationRoutes } from "../pages/location/location.route";
import { MarketingClaimRoutes } from "../pages/marketing_claim/marketing_claim.route";
import { MarketingDisbursementRoutes } from "../pages/marketing_disbursement/marketing_disbursement.route";
import { MarketingInvoiceRoutes } from "../pages/marketing_invoice/marketing_invoice.route";
import { MarketingSubscriptionRoutes } from "../pages/marketing_subscription/marketing_subscription.route";
import { NetworkGroupRoutes } from "../pages/network_group/network_group.route";
import { NetworkOLTRoutes } from "../pages/network_olt/network_olt.route";
import { NetworkONTRoutes } from "../pages/network_ont/network_ont.route";
import { NetworkONTBlockRoutes } from "../pages/network_ont_block/network_ont_block.route";
import { NetworkPOPRoutes } from "../pages/network_pop/network_pop.route";
import { NotificationRoutes } from "../pages/notification/notification.route";
import { PrivilegeRoutes } from "../pages/privilege/privilege.route";
import { ProductBroadbandRoutes } from "../pages/product_broadband/product_broadband.route";
import { ProductHotspotRoutes } from "../pages/product_hotspot/product_hotspot.route";
import { ProfileRoutes } from "../pages/profile/profile.route";
import { ProvisionRoutes } from "../pages/provision/provision.route";
import { ProvisionReturnRoutes } from "../pages/provision_return/provision_return.route";
import { RadiusAccountRoutes } from "../pages/radius_account/radius_account.route";
import { RadiusNASRoutes } from "../pages/radius_nas/radius_nas.route";
import { RadiusServerRoutes } from "../pages/radius_server/radius_server.route";
import { ResellerRoutes } from "../pages/reseller/reseller.route";
import { ResellerInvoiceRoutes } from "../pages/reseller_invoice/reseller_invoice.route";
import { SettingsRoutes } from "../pages/settings/settings.route";
import { SubscriptionRoutes } from "../pages/subscription/subscription.route";
import { SystemDisbursementRoutes } from "../pages/system_disbursement/system_disbursement.route";
import { WarehouseItemRoutes } from "../pages/warehouse_item/warehouse_item.route";
import { WarehouseItemTypeRoutes } from "../pages/warehouse_item_type/warehouse_item_type.route";
import { WarehouseLocationRoutes } from "../pages/warehouse_location/warehouse_location.route";
import { WhatsAppInvoiceRoutes } from "../pages/whatsapp_invoice/whatsapp_invoice.route";
import { WhatsAppMessageRoutes } from "../pages/whatsapp_message/whatsapp_message.route";
import { WhatsAppUsageRoutes } from "../pages/whatsapp_usage/whatsapp_usage.route";

export interface Menu {
    key: string;
    label: string;
    icon: string | Component;
    route?: string;
    items?: MenuItem[];
}

export interface PrimeMenu {
    key: string;
    label: string;
    icon: string | undefined;
    iconComponent?: Component;
    route?: string;
    items?: MenuItem[];
}

export interface MenuItem {
    key: string;
    label: string;
    route: string;
    privilege: Privilege.Names | Privilege.Names[] | "*";
}

export const mainMenu = [
    {
        key: "users",
        label: "Pengguna",
        icon: "pi pi-users",
        items: [
            {
                key: "profile",
                label: "Profil",
                route: ProfileRoutes.to.update(),
                privilege: "*",
            },
            {
                key: "admin",
                label: "Admin",
                route: AdminRoutes.to.record(),
                privilege: "admin.access",
            },
            {
                key: "privilege",
                label: "Hak Akses",
                route: PrivilegeRoutes.to.record(),
                privilege: "privilege.access",
            },
        ],
    },
    {
        key: "audit",
        label: "Audit",
        icon: "pi pi-list-check",
        items: [
            {
                key: "auditor",
                label: "Auditor",
                route: AuditorRoutes.to.record(),
                privilege: "auditor.access",
            },
            {
                key: "audit-subscription-select",
                label: "Langganan",
                route: AuditSubscriptionRoutes.to.selectRecord(),
                privilege: "audit.update",
            },
            {
                key: "audit-product-internet-select",
                label: "Produk Internet",
                route: AuditProductInternetRoutes.to.selectRecord(),
                privilege: "audit.update",
            },
        ],
    },
    {
        key: "associates",
        label: "Kemitraan",
        icon: "pi pi-sitemap",
        items: [
            {
                key: "associate",
                label: "Mitra",
                route: AssociateRoutes.to.record(),
                privilege: "associate.access",
            },
            {
                key: "associate-registration",
                label: "Registrasi Mitra",
                route: AssociateRegistrationRoutes.to.record(),
                privilege: "associate.access",
            },
            {
                key: "associate-user",
                label: "Karyawan / Pengguna",
                route: AssociateUserRoutes.to.record(),
                privilege: "associateUser.access",
            },
            {
                key: "associate-presence",
                label: "Kehadiran",
                route: AssociatePresenceRoutes.to.record(),
                privilege: "associateUser.access",
            },
            {
                key: "associate-settings",
                label: "Pengaturan Mitra",
                route: AssociateSettingsRoutes.to.update(),
                privilege: "associate.settings",
            },
            {
                key: "associate-wagent",
                label: "WA Unofficial (3P)",
                route: AssociateWagentRoutes.to.update(),
                privilege: "associate.settings",
            },
            {
                key: "api-key",
                label: "API Key",
                route: APIKeyRoutes.to.record(),
                privilege: "apiKey.access",
            },
        ],
    },
    {
        key: "marketing",
        label: "Pemasaran",
        icon: MarketingIcon,
        items: [
            {
                key: "associate-marketing",
                label: "Marketing",
                route: AssociateMarketingRoutes.to.record(),
                privilege: "associateUser.access",
            },
            {
                key: "marketing-claim",
                label: "Permohonan Saldo",
                route: MarketingClaimRoutes.to.record(),
                privilege: "financeAccount.access",
            },
            {
                key: "marketing-subscription",
                label: "Langganan",
                route: MarketingSubscriptionRoutes.to.record(),
                privilege: "associateUser.marketing",
            },
            {
                key: "marketing-invoice",
                label: "Tagihan Pelanggan",
                route: MarketingInvoiceRoutes.to.record(),
                privilege: "associateUser.marketing",
            },
            {
                key: "marketing-disbursement",
                label: "Penarikan Saldo",
                route: MarketingDisbursementRoutes.to.record(),
                privilege: "associateUser.marketing",
            },
        ],
    },
    {
        key: "internet",
        label: "Layanan Internet",
        icon: InternetIcon,
        items: [
            {
                key: "customer",
                label: "Pelanggan",
                route: CustomerRoutes.to.record(),
                privilege: "customer.access",
            },
            {
                key: "subscription",
                label: "Langganan",
                route: SubscriptionRoutes.to.record(),
                privilege: "customer.access",
            },
            {
                key: "customer-invoice",
                label: "Tagihan Bulanan",
                route: CustomerInvoiceRoutes.to.record(),
                privilege: "customerInvoice.access",
            },
            {
                key: "product-broadband",
                label: "Produk Broadband",
                route: ProductBroadbandRoutes.to.record(),
                privilege: "productBroadband.access",
            },
            {
                key: "audit-subscription",
                label: "Langganan",
                route: AuditSubscriptionRoutes.to.record(),
                privilege: "audit.access",
            },
            {
                key: "audit-product-internet",
                label: "Produk Internet",
                route: AuditProductInternetRoutes.to.record(),
                privilege: "audit.access",
            },
        ],
    },
    {
        key: "hotspot",
        label: "Layanan Hotspot",
        icon: HotspotIcon,
        items: [
            {
                key: "reseller",
                label: "Reseller",
                route: ResellerRoutes.to.record(),
                privilege: "reseller.access",
            },
            {
                key: "hotspot-voucher",
                label: "Voucher",
                route: HotspotVoucherRoutes.to.record(),
                privilege: "hotspotVoucher.access",
            },
            {
                key: "reseller-invoice",
                label: "Tagihan Top-up",
                route: ResellerInvoiceRoutes.to.record(),
                privilege: "financeInvoice.access",
            },
            {
                key: "product-hotspot",
                label: "Produk Hotspot",
                route: ProductHotspotRoutes.to.record(),
                privilege: "productHotspot.access",
            },
            {
                key: "hotspot-template",
                label: "Template",
                route: HotspotTemplateRoutes.to.record(),
                privilege: "hotspotVoucher.access",
            },
        ],
    },
    {
        key: "network",
        label: "Jaringan",
        icon: "pi pi-server",
        items: [
            {
                key: "network-group",
                label: "Alamat IPv4",
                route: NetworkGroupRoutes.to.record(),
                privilege: "networkGroup.access",
            },
            {
                key: "radius-nas",
                label: "NAS / Mikrotik",
                route: RadiusNASRoutes.to.record(),
                privilege: "radiusNAS.access",
            },
            {
                key: "network-olt",
                label: "OLT",
                route: NetworkOLTRoutes.to.record(),
                privilege: "networkOLT.access",
            },
            {
                key: "network-ont",
                label: "ONT",
                route: NetworkONTRoutes.to.record(),
                privilege: "networkONT.access",
            },
            {
                key: "network-ont-block",
                label: "ONT Block",
                route: NetworkONTBlockRoutes.to.record(),
                privilege: "dev.tools",
            },
            {
                key: "radius-account",
                label: "Akun RADIUS",
                route: RadiusAccountRoutes.to.record(),
                privilege: "radiusServer.access",
            },
            {
                key: "radius-server",
                label: "Server RADIUS",
                route: RadiusServerRoutes.to.record(),
                privilege: "radiusServer.access",
            },
            {
                key: "network-pop",
                label: "POP",
                route: NetworkPOPRoutes.to.record(),
                privilege: "locationPOP.access",
            },
        ],
    },
    {
        key: "agent",
        label: "Titip Bayar",
        icon: AgentIcon,
        items: [
            {
                key: "associate-agent",
                label: "Agen Pembayaran",
                route: AssociateAgentRoutes.to.record(),
                privilege: "associateUser.access",
            },
            {
                key: "agent-settlement",
                label: "Riwayat Setoran",
                route: AgentSettlementRoutes.to.record(),
                privilege: "associateUser.access",
            },
            {
                key: "agent-subscription",
                label: "Langganan",
                route: AgentSubscriptionRoutes.to.record(),
                privilege: "associateUser.agent",
            },
            {
                key: "agent-invoice",
                label: "Tagihan Pelanggan",
                route: AgentInvoiceRoutes.to.record(),
                privilege: "associateUser.agent",
            },
            {
                key: "agent-payment",
                label: "Riwayat Pembayaran",
                route: AgentPaymentRoutes.to.record(),
                privilege: "associateUser.agent",
            },
        ],
    },
    {
        key: "finance",
        label: "Keuangan",
        icon: "pi pi-money-bill",
        items: [
            {
                key: "finance-account",
                label: "Akun Keuangan",
                route: FinanceAccountRoutes.to.record(),
                privilege: "financeAccount.access",
            },
            {
                key: "finance-disbursement",
                label: "Penarikan Saldo",
                route: FinanceDisbursementRoutes.to.record(),
                privilege: "financeAccount.access",
            },
            {
                key: "system-disbursement",
                label: "Penarikan Saldo Sistem",
                route: SystemDisbursementRoutes.to.record(),
                privilege: "dev.tools",
            },
            {
                key: "finance-invoice",
                label: "Tagihan Umum",
                route: FinanceInvoiceRoutes.to.record(),
                privilege: "financeInvoice.access",
            },
            {
                key: "finance-tax",
                label: "Setoran Pajak",
                route: FinanceTaxRoutes.to.record(),
                privilege: "financeTax.access",
            },
        ],
    },
    {
        key: "report",
        label: "Laporan",
        icon: ReportIcon,
        items: [
            {
                key: "finance-report",
                label: "Pembayaran Tagihan Langganan & Top-up",
                route: FinanceReportRoutes.to.record(),
                privilege: "financeAccount.access",
            },
        ],
    },
    {
        key: "location",
        label: "Peta",
        icon: "pi pi-map",
        items: [
            {
                key: "location-customers",
                label: "Pelanggan",
                route: LocationRoutes.to.customer(),
                privilege: "customer.access",
            },
            {
                key: "location-resellers",
                label: "Reseller",
                route: LocationRoutes.to.reseller(),
                privilege: "reseller.access",
            },
            {
                key: "location-pops",
                label: "POP",
                route: LocationRoutes.to.pop(),
                privilege: "locationPOP.access",
            },
        ],
    },
    {
        key: "warehouse",
        label: "Pergudangan",
        icon: "pi pi-warehouse",
        items: [
            {
                key: "warehouse-item",
                label: "Barang",
                route: WarehouseItemRoutes.to.record(),
                privilege: "warehouseItem.access",
            },
            {
                key: "warehouse-item-group",
                label: "Jenis Barang",
                route: WarehouseItemTypeRoutes.to.record(),
                privilege: "warehouseItemType.access",
            },
            {
                key: "warehouse-location",
                label: "Lokasi Gudang",
                route: WarehouseLocationRoutes.to.record(),
                privilege: "warehouseLocation.access",
            },
            {
                key: "provision",
                label: "Permintaan Barang",
                route: ProvisionRoutes.to.record(),
                privilege: "warehouseRequest.access",
            },
            {
                key: "provision-return",
                label: "Pengembalian Barang",
                route: ProvisionReturnRoutes.to.record(),
                privilege: "warehouseRequest.access",
            },
        ],
    },
    {
        key: "legals",
        label: "Dokumen",
        icon: DocumentIcon,
        items: [
            {
                key: "legals-system",
                label: "Legalitas",
                route: LegalsRoutes.to.record(),
                privilege: "legals.access",
            },
            {
                key: "legals-associate",
                label: "Legalitas Mitra",
                route: AssociateLegalsRoutes.to.record(),
                privilege: "legals.access",
            },
        ],
    },
    {
        key: "notification",
        label: "Notifikasi",
        icon: NotificationIcon,
        items: [
            {
                key: "notification-send",
                label: "Kirim Notifikasi",
                route: NotificationRoutes.to.send(),
                privilege: "dev.tools",
            },
        ],
    },
    {
        key: "whatsapp",
        label: "WhatsApp",
        icon: WhatsAppIcon,
        items: [
            {
                key: "whatsapp-message",
                label: "Pesan Masuk",
                route: WhatsAppMessageRoutes.to.record(),
                privilege: "whatsApp.access",
            },
            {
                key: "whatsapp-usage",
                label: "Penggunaan Bulanan",
                route: WhatsAppUsageRoutes.to.record(),
                privilege: "whatsApp.access",
            },
            {
                key: "whatsapp-invoice",
                label: "Tagihan Penggunaan",
                route: WhatsAppInvoiceRoutes.to.record(),
                privilege: ["settings.update", "associate.admin"],
            },
        ],
    },
    {
        key: "settings",
        label: "Pengaturan",
        icon: "pi pi-cog",
        items: [
            {
                key: "settings-finance",
                label: "Keuangan",
                route: SettingsRoutes.to.finance(),
                privilege: "settings.access",
            },
            {
                key: "settings-profile",
                label: "Profil Perusahaan",
                route: SettingsRoutes.to.profile(),
                privilege: "settings.access",
            },
            {
                key: "settings-whatsapp",
                label: "WhatsApp",
                route: SettingsRoutes.to.whatsApp(),
                privilege: "settings.access",
            },
            {
                key: "settings-firebase",
                label: "Firebase",
                route: SettingsRoutes.to.firebase(),
                privilege: "settings.access",
            },
            {
                key: "settings-xendit",
                label: "Xendit",
                route: SettingsRoutes.to.xendit(),
                privilege: "settings.access",
            },
        ],
    },
    {
        key: "devtools",
        label: "DevTools",
        icon: DevToolsIcon,
        items: [
            {
                key: "dev-masquerade",
                label: "Masquerade",
                route: DevToolsRoutes.to.masquerade(),
                privilege: "dev.tools",
            },
            {
                key: "dev-database",
                label: "Database",
                route: DevToolsRoutes.to.database(),
                privilege: "dev.tools",
            },
            {
                key: "dev-maintenance",
                label: "Maintenance",
                route: DevToolsRoutes.to.maintenance(),
                privilege: "dev.tools",
            },
            {
                key: "dev-daemon",
                label: "Daemon",
                route: DevToolsRoutes.to.daemon(),
                privilege: "dev.tools",
            },
            {
                key: "dev-mobile",
                label: "Mobile",
                route: DevToolsRoutes.to.mobile(),
                privilege: "dev.tools",
            },
            {
                key: "dev-features",
                label: "Feature Toggles",
                route: FeatureTogglesRoutes.to.index(),
                privilege: "dev.tools",
            },
        ],
    },
    {
        key: "debug",
        label: "Debug Tools",
        icon: DebugIcon,
        items: [
            {
                key: "debug-database",
                label: "Database",
                route: DebugToolsRoutes.to.database(),
                privilege: "debug.tools",
            },
            {
                key: "debug-daemon",
                label: "Daemon",
                route: DebugToolsRoutes.to.daemon(),
                privilege: "debug.tools",
            },
            {
                key: "debug-notify",
                label: "Notify",
                route: DebugToolsRoutes.to.notify(),
                privilege: "debug.tools",
            },
            {
                key: "debug-whatsapp",
                label: "WhatsApp",
                route: DebugToolsRoutes.to.whatsApp(),
                privilege: "debug.tools",
            },
            {
                key: "debug-widgets",
                label: "Widgets",
                route: DebugToolsRoutes.to.widgets(),
                privilege: "debug.tools",
            },
        ],
    },
] as const satisfies Menu[];

export type MenuKeys = (typeof mainMenu)[number]["key"];
export type MenuItemKeys = (typeof mainMenu)[number]["items"][number]["key"];
